import React from "react";

const PermissionRoute = ({ children }) => {
  return children;
};

export default PermissionRoute;
